"use strict";

exports.__esModule = true;
exports["default"] = getArrayBufferFromFile;

var _isBrowser = _interopRequireDefault(require("./isBrowser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getArrayBufferFromFile(file) {
  if (!_isBrowser["default"]) {
    //node environment
    return toArrayBuffer(Buffer.isBuffer(file) ? file : file.buffer || file);
  }

  var reader = new window.FileReader();
  return new Promise(function (resolve, reject) {
    reader.onload = function (e) {
      resolve(e.target.result);
    };

    reader.onerror = function (err) {
      console.error("err:", err);
      reject(err);
    };

    reader.readAsArrayBuffer(Buffer.isBuffer(file) ? file : file.buffer || file);
  });
}

function toArrayBuffer(buffer) {
  var ab = new ArrayBuffer(buffer.length);
  var view = new Uint8Array(ab);

  for (var i = 0; i < buffer.length; ++i) {
    view[i] = buffer[i];
  }

  return ab;
}

module.exports = exports.default;